const capitalizeFirstLetter = (title: string): string => {
    const stringToCapitalize = title || ""
    return stringToCapitalize?.charAt(0).toUpperCase() + stringToCapitalize?.slice(1)
}
export default capitalizeFirstLetter

export const capitalizeFirstLetterOfEachWord = (stringToCapitalize?: string, stopWords?: string[]): string => {
    if (!stringToCapitalize) return ""
    return stringToCapitalize
        .split(" ")
        .map(word => (stopWords?.includes(word) ? word : capitalizeFirstLetter(word)))
        .join(" ")
}
